import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import LanguageToggle from "./LanguageToggle";
import { useLang } from "../i18n/LanguageContext";
import { useFavorites } from "../context/FavoritesContext";
import logo from "../assets/logoLong.png";

export default function Navbar() {
  const { t } = useLang();
  const { favorites } = useFavorites();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Nav $scrolled={scrolled}>
      <Brand to="/" aria-label="Amora Weddings">
        <img src={logo} alt="Amora Weddings" />
      </Brand>
      <Right>
        <NavLink to="/how">{t("nav.how")}</NavLink>
        <NavLink to="/list">{t("nav.forBusiness")}</NavLink>
        <Saved to="/saved">
          ♥ {t("nav.saved")}
          {favorites.length > 0 && <em>{favorites.length}</em>}
        </Saved>
        <LanguageToggle />
      </Right>
    </Nav>
  );
}

const Nav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px clamp(20px, 5vw, 64px);
  background: rgba(251, 247, 239, 0.82);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid
    ${({ $scrolled, theme }) => ($scrolled ? theme.colors.hair : "transparent")};
  transition: border-color 0.3s;
`;

const Brand = styled(Link)`
  display: flex;
  align-items: center;
  img {
    height: 60px;
    width: auto;
    display: block;
    @media (max-width: 640px) {
      height: 26px;
    }
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`;

const NavLink = styled(Link)`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.inkSoft};
  &:hover {
    color: ${({ theme }) => theme.colors.ink};
  }
  @media (max-width: 640px) {
    display: none;
  }
`;

const Saved = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.rose};
  em {
    font-style: normal;
    font-size: 11px;
    background: ${({ theme }) => theme.colors.rose};
    color: #fff;
    padding: 1px 6px;
    border-radius: 100px;
  }
  @media (max-width: 640px) {
    font-size: 0;
    gap: 0;
    em {
      font-size: 11px;
    }
  }
`;
